// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-pull-to-wrapper{background-color:#fff;position:absolute;top:0;bottom:0;left:0;width:100%}", ""]);
// Exports
module.exports = exports;
